module.exports = __webpack_public_path__ + "img/no-board.017f29a1.svg";